import { render, staticRenderFns } from "./CustomerCommunications.vue?vue&type=template&id=10e3d4c4&"
import script from "./CustomerCommunications.vue?vue&type=script&lang=js&"
export * from "./CustomerCommunications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports